export const DEACTIVATE_ADVERTISEMENT_START =
  'DEACTIVATE_ADVERTISEMENT_START';
export const DEACTIVATE_ADVERTISEMENT_SUCCESS =
  'DEACTIVATE_ADVERTISEMENT_SUCCESS';
export const DEACTIVATE_ADVERTISEMENT_ERROR =
  'DEACTIVATE_ADVERTISEMENT_ERROR';
